const cryptocurrency = {
  paymentMethodName: 'สกุลเงินดิจิทัล',
  cryptocurrencyLabel: 'สกุลเงินดิจิทัล',
  cryptocurrencySelectPlaceholder: 'เลือกสกุลเงินดิจิทัลของคุณ',
  protocolWarning: 'หากการชำระเงินทำผ่านเครือข่ายอื่นที่ไม่ใช่ที่เลือก เงินอาจสูญหายอย่างถาวร กรุณา<b>ตรวจสอบให้แน่ใจว่ากระเป๋าเงินของคุณตั้งค่าสำหรับเครือข่ายที่ถูกต้อง</b>ก่อนดำเนินการ',
  networkLabel: 'เครือข่าย',
  networkSelectPlaceholder: 'เลือกเครือข่ายของคุณ',
  paymentButtonLabel: 'ชำระด้วยสกุลเงินดิจิทัล',
  amountLocal: 'จำนวนเงินท้องถิ่น',
  amountCrypto: 'จำนวนเงินคริปโต',
  paymentCreatedTitle: 'การชำระเงินของคุณถูกสร้างแล้ว!',
  paymentCreatedSubtitle: 'คำสั่งซื้อของคุณจะเสร็จสมบูรณ์ในไม่ช้า! ทำตามคำแนะนำด้านล่างเพื่อยืนยันธุรกรรมนี้',
  qrCodeInstruction: 'สแกน QR code ด้านล่างในกระเป๋าเงินของคุณเพื่อดำเนินการชำระเงินในไม่กี่วินาที',
  qrCodeNetworkNotFound: 'ไม่พบเครือข่าย กรุณาตรวจสอบว่าคุณเลือกเครือข่ายที่ถูกต้องแล้ว',
  networkWarning: 'คุณกำลังชำระ <b>{cryptocurrency}</b> โดยใช้ <b>{protocol}</b> ตรวจสอบให้แน่ใจว่าเลือกเครือข่ายที่ถูกต้องในกระเป๋าเงินของคุณ มิฉะนั้นเงินของคุณอาจสูญหาย',
  conversionRate: 'มูลค่าที่แปลงแล้วคือ 1 {currencyExt} = {formattedCryptoRate} {cryptocurrency} มูลค่านี้คำนวณแบบเรียลไทม์และอาจผันผวนตามอัตราแลกเปลี่ยน',
  paymentApproved: 'การชำระเงินของคุณจำนวน <AmountText>{amountLocal}</AmountText> ได้รับการอนุมัติแล้ว',
  howToPayInfoTitle: 'วิธีชำระด้วยคริปโต?',
  howToPayOpenApp: 'เปิดกระเป๋าเงินของคุณ (แอปหรือส่วนขยาย) แล้วแตะที่ตัวเลือก ซื้อ โอน ส่ง หรือ ชำระ',
  howToPayQrCode: 'สแกน QR code และกรอกข้อมูลที่จำเป็นโดยใช้การคัดลอกและวาง',
  howToPayNetwork: 'ตรวจสอบให้แน่ใจว่าคุณเลือกเครือข่ายที่ถูกต้อง หากเลือกผิด เงินอาจไม่สามารถกู้คืนได้',
  howToPayConfirmation: 'ติดตามสถานะในกระเป๋าเงินของคุณ (กิจกรรม/ประวัติ) หรือกลับมาที่หน้านี้เพื่อรอการยืนยัน',
  payAgreement1: 'เมื่อดำเนินการต่อ คุณยอมรับ',
  serviceTerms: 'ข้อกำหนดและเงื่อนไข',
  payAgreement2: 'ของ EBANX',
  payWithWalletButton: 'ชำระเงินด้วยกระเป๋าเงินคริปโต',
  walletRedirectInstruction: 'คุณสามารถชำระเงินได้โดยคลิกที่ปุ่มและจะถูกนำไปยังหน้าเพื่อทำการชำระเงินให้เสร็จสมบูรณ์',
  manualQrCodeInstruction: 'หรือสแกน QR Code ด้านล่างด้วยตนเองเพื่อดำเนินการชำระเงิน',

};

module.exports = cryptocurrency;
